import React, { Component, Suspense } from "react";
import edit from "../image/icons/edit.png"
import plus from "../image/icons/plus.png"
import * as ReactDOM from "react-dom";
import $ from 'jquery'
//const DentalTreatments = 'https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/dentaldesigns/DentalTreatments.png'
const folderName = window.sessionStorage.getItem("homeName");

export default class MiddleBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      specialitiesData: [],
      sectionName:'Specialities',
      parentName:'',
    };
  }
  componentDidMount() {
    const speciality = JSON.parse(window.sessionStorage.getItem("Specialities"));
    if (speciality) {
      this.setState({ specialitiesData: speciality});
      this.setState({ parentName: speciality[0].parentName })
    } else {
      // window.location.reload(false);
    }
  }
  addClick (sid,pId,cId,psubTitle,cTitile,cdescri,childUrl,childImg,sOrder) {
    
    if($("#SpecialitiesParentId").val()!=""){
      pId=$("#SpecialitiesParentId").val();
    }
    if(childImg){
      var splitImg=childImg.split("theme/")
      childImg=splitImg[1];
      }

    const LazyPage = React.lazy(() => import("../" + folderName + "/ThemeComponent"));
    ReactDOM.render(
      <div>
        <Suspense fallback={<div>Loading...</div>}>
          <section>
            <LazyPage  sessionId={sid} 
            parentId={pId}
            childId={cId}
            patentTitle={this.state.parentName}
            parentSubTitle={psubTitle}
            childTitle={cTitile}
            childDesri={cdescri}
            sectionName={this.state.sectionName}
            childUrl={childUrl}
            childImg={childImg}
            sortSubOrder={sOrder}
            />
          </section>
        </Suspense>
      </div>,
      document.getElementById("specialitypopUpBlock")
    );
    $("#specialitypopUpBlock").addClass('editActive');
  }
    
     render(){

       return (
        <div class="mentalMiddleBanner dashContent">
          <div class="container text-center">
            <h4 class="mainHead text-center">{this.state.parentName!= '' ? this.state.parentName : 'Our Services'}</h4>
            {this.props.themeFlag === "theme" && (
            <div className="editIconSec" id="Specialities">
         <span className="editIcon editAddIcon" title="Add" onClick={() => this.addClick("7","","","","","","","","")}><img src={plus} alt="Add"/></span>
          </div>
            )}
          <div className="cmsContentDiv dashContent" id="specialitypopUpBlock"></div>        
            <input type="hidden" id="SpecialitiesSectionId" value="7"/>
            {this.state.specialitiesData.map((ban) => {
                return (
                <div>  
             <input type="hidden" id="SpecialitiesParentId" value={ban.parentId} />
              {ban.sectionList.length != "0" && (
              <div>
              {ban.sectionList.map((data)=> (
            <div class="treatmentList">
            
                {this.props.themeFlag === "theme" && (
                <div className="editIconSec editIconSecTop">
                 <span className="editIcon editAddIcon" title="Edit" 
                 onClick={() => this.addClick
                 (ban.sectionId,
                 ban.parentId,
                 data.childId,
                 ban.parentSubTitle,
                 data.childName,
                 data.childDescription,
                 data.childUrl,
                 data.childImage,
                 data.homeAdsSubSortOrder)}><img src={edit} alt="logo"/></span>
                 </div>
                )}
                <a href={data.childUrl} >
                  <img src={data.childImage} class="mb-3" />
                  {data.childName!="@" ? (
                  <h5>{data.childName}</h5>  
                  ) : ''}
                  <p>{data.childDescription} </p>
                </a>
            </div>
               ))}
            </div>
              )}
            </div>
                );
              })}
          </div>
          
        </div>
       )
     }
   }
